import React, { useState, useEffect } from "react";


// Section Components
import SectionTitle from "./components/SectionTitle";

// Table Components
import AbandonedCarts from "./components/tables/AbandonedCarts";
import LowStocks from "./components/tables/LowStocks";
import TopSelling from "./components/tables/TopSelling";
import LatestOrders from "./components/tables/LatestOrders";
import Stats from "./components/Stats";
import OrderStatus from "./components/OrderStatus";
import RecentSales from "./components/RecentSales";
import SetUpStatus from "./components/SetUpStatus";
import StatusSkeleton from "./components/SetUpStatus/StatusSkeleton";
import ChartSkeleton from "./components/OrderStatus/components/ChartSkeleton";

const Dashboard = () => {

    const [setupSteps, setSetupSteps] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const url = `${EASYCOMMERCE.rest_base}/dashboard/setup_status`;
    
        fetch(url, {
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            },
        })
            .then((res) => res.json())
            .then((data) => {
                setIsLoading(false);
    
                if (data.success && data.data?.setupSteps) {
                    setSetupSteps(data.data.setupSteps);
                }
            });
    }, []);

    const isSetupComplete = setupSteps.every(step => step.status);

    return (
        <>
            <div className="mt-3">
                <div className="grid grid-cols-12 gap-6">
                    <Stats />
                    <div className="col-span-12 min-[1400px]:col-span-4 bg-white rounded-xl">
                        {isLoading ? (
                            isSetupComplete ? <ChartSkeleton /> : <StatusSkeleton />
                        ) : (
                            isSetupComplete ? <OrderStatus /> : <SetUpStatus setupSteps={setupSteps} />
                        )}
                    </div>

                    <RecentSales />
                    <div className={`col-span-12 min-[1685px]:col-span-6 bg-white rounded-xl flex flex-col justify-between gap-6`}>
                        <div className="flex flex-col gap-[24px]">
                            <div className=" border-b border-ec-table-stock">
                                <SectionTitle title="Abandoned Carts" />
                            </div>
                            <AbandonedCarts />
                        </div>
                        {/* <DashboardButton url={`admin.php?page=easycommerce-store#/abandoned-cart`} /> */}
                    </div>

                    <div className={`col-span-12 min-[1700px]:col-span-6 bg-white rounded-xl flex flex-col justify-between gap-6`}>
                        <div className="flex flex-col gap-[24px] w-full">
                            <div className=" border-b border-ec-table-stock">
                                <SectionTitle title="Latest Orders" />
                            </div>
                            <LatestOrders />
                        </div>
                        {/* <DashboardButton url={`admin.php?page=easycommerce-store#/orders`} /> */}
                    </div>

                    <div className={`col-span-12 xl:col-span-6 min-[1700px]:col-span-3 bg-white rounded-xl flex flex-col justify-between gap-6`}>
                        <div className="flex flex-col gap-[24px] w-full">
                            <div className=" border-b border-ec-table-stock">
                                <SectionTitle title="Low Stock Products" />
                            </div>
                            <LowStocks />
                        </div>
                        {/* <DashboardButton url={`admin.php?page=easycommerce-store#/abandoned-cart`} /> */}
                    </div>

                    <div className={`col-span-12 xl:col-span-6 min-[1700px]:col-span-3 bg-white rounded-xl flex flex-col justify-between gap-6`}>
                        <div className="flex flex-col gap-[24px] w-full">
                            <div className=" border-b border-ec-table-stock">
                               <SectionTitle title="Top Selling Products" />
                            </div>
                            <TopSelling />
                        </div>
                        {/* <DashboardButton url={`admin.php?page=easycommerce-store#/reports`} /> */}
                    </div>
                </div>
            </div>
        </>

    );
};

export default Dashboard;
